export default "__VITE_ASSET__g28cTmkQ__"